
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26 6.369a9.83 9.83 0 01-2.717.744 4.689 4.689 0 002.074-2.606 9.422 9.422 0 01-2.99 1.141 4.714 4.714 0 00-8.156 3.224c0 .374.032.734.11 1.076-3.92-.191-7.39-2.07-9.72-4.932a4.747 4.747 0 00-.645 2.383c0 1.633.84 3.08 2.094 3.919a4.656 4.656 0 01-2.13-.58v.05a4.737 4.737 0 003.778 4.634 4.704 4.704 0 01-1.237.155c-.301 0-.606-.017-.892-.08.61 1.867 2.344 3.24 4.406 3.284a9.475 9.475 0 01-5.847 2.011A8.82 8.82 0 013 20.728a13.274 13.274 0 007.233 2.116c8.677 0 13.421-7.188 13.421-13.418 0-.208-.007-.41-.017-.61A9.405 9.405 0 0026 6.37z","fill":"#ACACAC"}})])
          )
        }
      }
    